import React from 'react';
import I18n from 'i18n-js';
import useDismissibleAlert from '@reverbdotcom/commons/src/components/use_dismissible_alert';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';
import { trackEvent } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { RCCloseButton } from '@reverbdotcom/commons/src/rc/RCCloseButton';

export const COMPONENT_NAME = 'SecondaryNagBanner';
const DISMISSIBLE_KEY = 'secondary_marketing_banner_september_30_contents';

function SecondaryNagBanner() {
  const [dismissed, dismiss] = useDismissibleAlert(DISMISSIBLE_KEY);

  if (dismissed) {
    return null;
  }

  const onDismiss = () => {
    dismiss();

    trackEvent({
      eventName: MParticleEventName.DismissedSecondaryNagBanner,
      componentName: COMPONENT_NAME,
    });
  };

  return (
    <div className="secondary-nag-banner">
      <div className="secondary-nag-banner__inner">
        <div className="secondary-nag-banner__text">
          <span className="mr-half">{I18n.t('discovery.secondaryNagBanner.content')}</span>
          <CoreLink
            to="/"
            className="secondary-nag-banner__link"
            clickEvent={{
              eventName: MParticleEventName.ClickedSecondaryNagBannerCalloutAction,
              componentName: COMPONENT_NAME,
            }}
          >
            {I18n.t('discovery.secondaryNagBanner.cta')}
          </CoreLink>
          <RCCloseButton
            onClick={onDismiss}
            aria-label={I18n.t('discovery.secondaryNagBanner.dismissButton')}
          />
        </div>
      </div>
    </div>
  );
}

export default SecondaryNagBanner;
